/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useContext } from "react";
import { Box, Text } from "@nordcloud/gnui";
import { InlineEditText } from "~/components/InlineEdit/InlineEditText";
import { DetailRow } from "~/components/Utils/DetailRow";
import { ApplicationViewCtx } from "~/views/customer/applications/ApplicationViewCtx";

function ServiceDescription() {
  const { application, updateApplication, canEdit } = useContext(
    ApplicationViewCtx
  );

  return (
    <Box spacing="spacing04">
      <Text weight="medium">Service Description</Text>

      <DetailRow title="Description">
        <InlineEditText
          name="serviceDescription"
          defaultValue={application.serviceDescription}
          onSubmit={(val) => updateApplication({ serviceDescription: val })}
          canEdit={canEdit}
          textArea
        />
      </DetailRow>
    </Box>
  );
}

export { ServiceDescription };
